import React from 'react';
import Layout from '../components/Layout';
import ExperiencesComponent from '../components/Experiences';

function Experiences() {
  return (
    <Layout>
      <ExperiencesComponent />
    </Layout>
  );
}

export default Experiences;
